<div class="icon-container flex-none align-items-center justify-center body-medium cursor-pointer" aria-label="Back to top" (click)="scrollToTop()">
    <i class="fas fa-lg fa-angle-double-up"></i>
</div>
